import { useCallback } from 'react';

import {
  type Upload,
  UploadStatus,
  uploadByIdSelector,
  uploadHasUploadInfo,
  useUploaderStore,
} from '@air/redux-uploader';

export const useCanLargeChunkBeUploaded = () => {
  const store = useUploaderStore();

  const canLargeChunkBeUploaded = useCallback(
    (uploadId: Upload['id']) => {
      const upload = uploadByIdSelector(store.getState(), uploadId);
      return !!upload && uploadHasUploadInfo(upload) && upload.status !== UploadStatus.paused;
    },
    [store],
  );

  return {
    canLargeChunkBeUploaded,
  };
};
